@import '../../index.css';

.container {
  display: flex;
  flex-direction: column;
  font-family: 'Poppins', sans-serif;
  padding-top: 120px;
  background-color: #fef5e7;
}

.topBackgroundImageWrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.topBgPinWrapper {
  position: relative;
  pointer-events: none;
  /*background-color: #ff5a1f33;*/
}

.topBackgroundImageWrapper1 {
  background: url('../../assets/images/banner-bg-team.webp') no-repeat top;
  background-size: contain;
  position: absolute;
  z-index: 100;
  width: 100vw;
  height: 100vw;
  top: 0;
  left: 0;
  right: 0;
  /*background-color: #ff5a1f33;*/
}

.reviewContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.stackedImages {
  margin-top: 48px;
  align-self: center;
}

.rating {
  margin-top: 12px;
  color: #525252;
  font-size: 14px;
  line-height: 21px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  align-self: center;
}

.title {
  text-align: center;
  margin-top: 16px;
  color: #1a1a1a;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  font-size: 36px;
  line-height: 52px;
  white-space: pre-wrap;
  margin-left: 22px;
  margin-right: 22px;
}

.logoText {
  color: #ff9f2f;
}

.description {
  text-align: center;
  color: #525252;
  font-size: 16px;
  line-height: 24px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  margin: 16px 16px 0 16px;
  max-width: 500px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.teamMemberDescription {
  text-align: center;
  color: #525252;
  font-size: 16px;
  line-height: 24px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  margin: 16px 16px 0 16px;
}

.buttonsRow {
  display: flex;
  gap: 12px;
  height: 56px;
  margin: 28px 16px 0 16px;
  max-width: 365px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.buttonsRow > * {
  flex: 1;
  min-width: 0;
}

.staticCenterLogos {
  margin-top: 100px;
}

.featureCard {
  margin: 8px 16px 0 16px;
  opacity: 0.5;
}

.miniPt {
  width: 50px;
  height: auto;
  display: inline-block;
  vertical-align: middle;
}

.mobileMockup {
  max-width: 300px;
  height: auto;
  margin-top: 40px;
}

.bestTimeHeadingText {
  font-family: 'Poppins', sans-serif;
  font-size: 36px;
  line-height: 52px;
  font-weight: 600;
  color: #04051b;
  margin-top: 100px;
  text-align: center;
}

.bestTimeSubHeadingText {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #525252;
  margin-top: 16px;
  text-align: center;
  margin-left: 16px;
  margin-right: 16px;
}

.featureCardWrapper {
  margin-top: 28px;
}

.bestTimeHeadingHighlight {
  color: #ffa100;
}

.whatsMakeUniqueText {
  font-family: 'Poppins', sans-serif;
  font-size: 36px;
  line-height: 52px;
  font-weight: 600;
  color: #04051b;
  text-align: center;
  margin-top: 48px;
}

.buttonsRowBottom {
  display: flex;
  gap: 12px;
  height: 56px;
  margin: 30px 16px 0 16px;
}

.buttonsRowBottom > * {
  flex: 1;
  min-width: 0;
}

.trackProgress {
  align-self: baseline;
  margin-left: 16px;
  margin-top: 28px;
  /*background-color: #ff9f2f;*/
}

.trackTitle {
  font-family: 'Poppins', sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: #04051b;
}

.trackDescription {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #525252;
  margin-top: 14px;
  margin-right: 16px;
}

.trackIndex {
  font-size: 14px;
  background: #d2f4bc;
  padding: 4px 12px;
  border-radius: 12px;
  margin-left: 12px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  color: #04051b;
}

.trackProgressCheckmarks {
  align-self: baseline;
  background: #fef5e7;
  margin-left: 16px;
  margin-top: 20px;
}

.meetTeamWrapper {
  background: url('../../assets/images/banner-bg-team.webp') no-repeat top;
  background-size: contain;
  margin-top: 48px;
  padding-left: 20px;
  padding-right: 20px;
  overflow-x: hidden;
}

.teamMemberCardContainer {
  margin: 0 16px;
}

.teamMemberCard {
  margin-top: 28px;
}

.motivationSection {
  margin-top: 48px;
}

.userTestimonials {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.exploreBlog {
  margin: 48px 0 0 0;
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
}

.mainFooter {
  margin: 0 0;
  display: flex;
  flex-direction: column;
}

.trackWrapper {
  display: block;
}

.trackImage {
  display: block;
  /*background-color: red;*/
  align-self: center;
  width: 100%;
}

.mobileVideoContainer {
  margin-top: -4rem;
  margin-bottom: -12rem;
}

.cssMobileVideoContainer {
  margin-top: 26px;
  /*This make sure mobile does not cut from top when rotating*/
  align-items: center;
  justify-content: center;
  display: flex;
  /*background-color: red;*/
}

.phonePinWrapper {
  position: relative;
  pointer-events: none;
  /*background-color: green;*/

  /*margin-top: -700px;*/
  /*opacity: 0.4;*/
}

/* DESKTOP RESPONSIVE BREAKPOINT */
@media (min-width: 900px) {
  .topBackgroundImageWrapper1 {
    background: url('../../assets/images/banner-bg-mobile-main.webp') no-repeat center;
    background-size: cover;
    position: absolute;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    /*background-color: #ff5a1f33;*/
  }

  .reviewContainer {
    display: flex;
    flex-direction: row;
    align-self: center;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 94px;
  }

  .stackedImages {
    margin-top: 0;
  }

  .rating {
    margin-top: 0;
  }

  .title {
    text-align: center;
    margin-top: 16px;
    color: #1a1a1a;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    font-size: 76px;
    line-height: 114px;
    white-space: pre-wrap;
  }

  .description {
    font-size: 20px;
    line-height: 30px;
    margin-top: 24px;
    max-width: 620px;
    /* controls 2-line wrap */
    align-self: center;
    text-align: center;
  }

  .buttonsRow {
    display: flex;
    gap: 12px;
    height: 56px;
    max-width: 236px;
    align-self: center;
  }

  .bestTimeHeadingText {
    font-size: 48px;
  }

  .bestTimeHeadingText br {
    display: none;
  }

  .whatsMakeUniqueText br {
    display: none;
  }

  .mb60 {
    margin-bottom: 60px;
  }

  .featureCardWrapper {
    margin-top: 28px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .buttonsRowBottom {
    display: flex;
    gap: 12px;
    height: 56px;
    max-width: 336px;
    align-self: center;
  }

  .trackWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    /*gap: 72px;*/
    /*margin-top: 120px;*/
    flex-direction: row-reverse;
    /*background-color: #ff9f2f;*/
    width: 80%;
    /*align-self: center;*/
    margin-top: 48px;
  }

  .trackRightBlock {
    /*background-color: green;*/
    width: 36%;
    margin-left: 10%;
  }

  .trackProgress {
    margin: 0;
  }

  .trackProgressCheckmarks {
    margin: 28px 0 0 0;
    background: none;
    /* desktop doesn't use the yellow box */
    padding: 0;
  }

  /* Desktop typography based on screenshot */
  .trackTitle {
    font-size: 48px;
    line-height: 52px;
  }

  .trackDescription {
    font-size: 20px;
    line-height: 30px;
    margin-top: 16px;
    font-weight: 400;
    color: #525252;
    font-family: 'Poppins', sans-serif;
  }

  .teamMemberDescription {
    text-align: center;
    color: #525252;
    font-size: 16px;
    line-height: 24px;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    margin-left: auto;
    margin-right: auto;
    max-width: 620px;
    /* controls 2-line wrap */
  }

  .teamMemberCardContainer {
    margin: 0 auto;
    /* center whole container */
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 32px;
    /* spacing between cards */
    max-width: 1215px;
    /* keeps layout balanced like screenshot */
  }

  .teamMemberCard {
    margin-top: 0;
    /* remove mobile spacing */
    flex: 0 0 33.3333%;
    /* fixed symmetrical card width */
  }

  .bestTimeSubHeadingText {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    color: #525252;
    margin-top: 16px;
    text-align: center;
  }
}

@media (max-width: 767.98px) {
  .mobileVideoContainer {
    margin-top: 4rem;
    margin-bottom: -9rem;
  }

  .userTestimonials {
    padding-top: 3rem;
    padding-bottom: 0rem;
  }

  .mobileVideoContainer {
    margin-top: 4rem;
    margin-bottom: -9rem;
  }
}

.mcards {
  position: relative;
  display: flex;
  flex-direction: column;
}

.mcard {
  backface-visibility: hidden;
  transform: translateZ(0);
  will-change: transform, opacity;

  max-width: 250px;
  height: auto;
  margin-top: 28px;
  align-self: center;
  padding-top: 28px;
}

@media (max-width: 1199.98px) {
  .teamMemberCard {
    flex: 0 0 40%;
  }

  .teamMemberCardContainer {
    flex-wrap: wrap;
    /* width: 100%; */
    display: flex;
    justify-content: center;
    gap: 30px;
    margin: 0;
  }

  .featureCardWrapper {
    display: flex;
    padding-left: 20px;
    padding-right: 20px;
  }

  .featureCardWrapper .featureCard {
    width: 33.3333%;
    margin: 0 0.75rem;
  }

  .buttonsRowBottom {
    max-width: 236px;
    width: 100%;
    margin: 2rem auto;
  }
}

@media (max-width: 991.98px) {
  .teamMemberCard {
    flex: 0 0 30%;
  }
}

@media (max-width: 767.98px) {
  .featureCardWrapper {
    flex-direction: column;
  }

  .featureCardWrapper .featureCard {
    width: 80%;
    margin: 0 auto;
    margin-bottom: 1.5rem;
  }
}

@media (max-width: 575.98px) {
  .teamMemberCard {
    flex: 0 0 100%;
  }

  .featureCardWrapper .featureCard {
    width: 100%;
  }

  .buttonsRowBottom,
  .buttonsRow {
    margin: 0 auto;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }

  .buttonsRow {
    margin-top: 2rem;
  }

  .teamMemberCardContainer {
    gap: 0;
  }
}

.fadeOnScroll {
  will-change: opacity;
}
